import React from 'react';

import type { TableGridView } from '@gitbook/doc-core';
import { Switch } from '@gitbook/spine-react';

import { DEFAULT_TABLE_COLUMN_WIDTH } from '../../../common';
import { ColumnWidthsContext } from '../../utils/contexts';
import type { DefinitionSettingsProps } from '../types';

/**
 * Settings for Grid columns.
 */
export function GridDefinitionSettings(
    props: DefinitionSettingsProps<TableGridView>
): React.ReactElement {
    const { view, columnId, setView } = props;
    const widths = React.useContext(ColumnWidthsContext);

    function onAutoSizeChange(enabled: boolean) {
        if (enabled) {
            const { [columnId]: id, ...otherWidths } = view.columnWidths || {};

            setView({
                ...view,
                useNewSizing: true,
                columnWidths: otherWidths,
            });
        } else {
            setView({
                ...view,
                useNewSizing: true,
                columnWidths: {
                    ...view.columnWidths,
                    [columnId]: widths.get(columnId) || DEFAULT_TABLE_COLUMN_WIDTH,
                },
            });
        }
    }

    return (
        <>
            <Switch
                value={typeof view.columnWidths?.[columnId] === 'undefined'}
                onValueChange={onAutoSizeChange}
                label="Fill available space"
                labelDescription="Expand this column to fill the available horizontal space"
            />
        </>
    );
}
